import ReactGA from "react-ga";
ReactGA.initialize("UA-178454842-1");
export default ReactGA;
